(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yg-banner-tabs-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGBannerTabs01 extends HTMLElement {
      constructor() {
        super();
      }

      get sectionsEl() {
        if (this._sectionsEl) return this._sectionsEl;

        this._sectionsEl = {
          'tabs-container': this.querySelector('.yg-tabs-title-container'),
          'tabs': this.querySelectorAll('.yg-banner-tab-title'),
          'swiper': this.querySelector(".yg-banner-swiper")
        };

        return this._sectionsEl;
      }

      connectedCallback() {
        // 获取swiper元素
        if (this.sectionsEl['swiper']&&this.sectionsEl['tabs-container']) {
          this.sectionsEl['swiper'].swiper.on('slideChange', (e) => {
            let realIndex = e.realIndex;
            this.sectionsEl['tabs-container'].toggleClass(this.sectionsEl['tabs'][realIndex], realIndex)
          });
        }
        if (this.sectionsEl['tabs']) {
          this.sectionsEl['tabs'].forEach((tab, index) => {
            tab.addEventListener('click', () => this.sectionsEl['swiper'].swiper.slideToLoop(index))
          });
        }
        
      }
    }
    if (!customElements.get('yg-banner-tabs-01')) {
      customElements.define('yg-banner-tabs-01', YGBannerTabs01);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-banner-tabs-02"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGBannerTabs02 extends HTMLElement {
      constructor() {
        super();
      }

      get sectionsEl() {
        if (this._sectionsEl) return this._sectionsEl;

        this._sectionsEl = {
          'tabs-container': this.querySelector('.yg-tabs-title-container'),
          'tabs': this.querySelectorAll('.yg-banner-tab-title'),
          'swiper': this.querySelector(".yg-banner-swiper")
        };

        return this._sectionsEl;
      }

      connectedCallback() {
        // 获取swiper元素
        if (this.sectionsEl['swiper']&&this.sectionsEl['tabs-container']) {
          this.sectionsEl['swiper'].swiper.on('slideChange', (e) => {
            let realIndex = e.realIndex;
            this.sectionsEl['tabs-container'].toggleClass(this.sectionsEl['tabs'][realIndex], realIndex)
          });
        }
        if (this.sectionsEl['tabs']) {
          this.sectionsEl['tabs'].forEach((tab, index) => {
            tab.addEventListener('click', () => this.sectionsEl['swiper'].swiper.slideToLoop(index))
          });
        }
        
      }
    }
    if (!customElements.get('yg-banner-tabs-02')) {
      customElements.define('yg-banner-tabs-02', YGBannerTabs02);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-echo-functions"] && !Shopify.designMode) return;
  try {
    
  class YGEchoFunctions extends HTMLElement {
    connectedCallback() {
      this.tabsTitle = this.querySelector('yg-tabs-title');
      this.tabs = Array.from(this.querySelectorAll('yg-tabs-title [data-echo-tab]'));
      this.mediaRow = this.querySelector('.yg-echo-functions-media-row');
      this.mediaItems = Array.from(this.querySelectorAll('[data-echo-media]'));
      this.descriptions = Array.from(this.querySelectorAll('[data-echo-description]'));
      this.activeIndex = Number(this.dataset.activeIndex || 0);

      this.tabsTitle?.addEventListener('click', this.handleTabClick);
      window.addEventListener('resize', this.handleResize);

      this.addEventListener('shopify:block:select', this.handleBlockSelect);
      this.setActive(this.activeIndex);

      window.requestAnimationFrame(() => {
        this.setActive(this.activeIndex, {
          scroll: true,
          behavior: 'auto'
        });
      });
    }

    disconnectedCallback() {
      this.tabsTitle?.removeEventListener('click', this.handleTabClick);
      window.removeEventListener('resize', this.handleResize);

      this.removeEventListener('shopify:block:select', this.handleBlockSelect);
    }

    handleTabClick = (event) => {
      const selectedTab = event.target.closest('[data-echo-tab]');

      if (selectedTab) {
        this.setActive(Number(selectedTab.dataset.index || 0), {
          scroll: true
        });
      }
    };

    handleBlockSelect = (event) => {
      const selectedMedia = event.target.closest('[data-echo-media]');

      if (selectedMedia) {
        this.setActive(Number(selectedMedia.dataset.index || 0), {
          scroll: true
        });
      }
    };

    handleResize = () => {
      window.requestAnimationFrame(() => {
        this.updateMediaPosition();
      });
    };

    setActive(index, options = {}) {
      const itemCount = this.mediaItems.length;

      if (!itemCount) return;

      index = Math.min(Math.max(index, 0), itemCount - 1);
      this.activeIndex = index;
      this.dataset.activeIndex = index;

      this.mediaItems.forEach((media) => {
        const mediaIndex = Number(media.dataset.index);

        media.classList.toggle('is-active', mediaIndex === index);
      });

      this.updateMediaPosition();
      this.updateVideoPlayback();

      this.tabs.forEach((tab) => {
        const isActive = Number(tab.dataset.index) === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.descriptions.forEach((description) => {
        description.classList.toggle('is-active', Number(description.dataset.index) === index);
      });

      if (this.tabsTitle && typeof this.tabsTitle.updateStyle === 'function') {
        this.tabsTitle.updateStyle(this.tabs[index]);
      }

      if (options.scroll && this.tabsTitle && typeof this.tabsTitle.scrollItemIntoView === 'function') {
        this.tabsTitle.scrollItemIntoView(this.tabs[index], {
          behavior: options.behavior || 'smooth'
        });
      }
    }

    updateMediaPosition() {
      const activeMedia = this.mediaItems[this.activeIndex];

      if (!this.mediaRow || !activeMedia) return;

      const itemCount = this.mediaItems.length;
      const step = this.mediaItems[1]
        ? this.mediaItems[1].offsetLeft - this.mediaItems[0].offsetLeft
        : activeMedia.offsetWidth;

      this.mediaItems.forEach((media) => {
        const mediaIndex = Number(media.dataset.index);
        const targetSlot = (mediaIndex - this.activeIndex + itemCount + 1) % itemCount;
        const offset = (targetSlot - mediaIndex) * step;

        media.style.transform = `translateX(${offset}px)`;
      });
    }

    updateVideoPlayback() {
      this.mediaItems.forEach((media) => {
        const mediaIndex = Number(media.dataset.index);
        const video = media.querySelector('yg-video');

        if (!video) return;

        if (mediaIndex === this.activeIndex && typeof video.playVideo === 'function') {
          video.playVideo();
          return;
        }

        if (typeof video.pauseVideo === 'function') {
          video.pauseVideo();
        }
      });
    }
  }

  if (!window.customElements.get('yg-echo-functions')) {
    window.customElements.define('yg-echo-functions', YGEchoFunctions);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-process-steps"] && !Shopify.designMode) return;
  try {
    
  class YGProcessSteps extends HTMLElement {
    #sectionEl;
    constructor() {
      super();
      this.currentStepIndex = 0;
      this.isInViewport = false;
      this.hasStarted = false;
      this.intersectionObserver = null;
      this.handleDropdownOpen = this.handleDropdownOpen.bind(this);
      this.handleProgressEnd = this.handleProgressEnd.bind(this);
      this.handleIntersection = this.handleIntersection.bind(this);
    }

    get $sectionEl() {
      if (this.#sectionEl) return this.#sectionEl

      this.#sectionEl = {
        'accordionList': this.querySelectorAll('.yg-process-steps-item'),
        'progressBars': this.querySelectorAll('.yg-process-steps-progress-bar'),
        'controls': this.querySelectorAll('.yg-process-steps-media')
      }

      return this.#sectionEl
    }

    connectedCallback() {
      document.addEventListener('YG:dropdown-open', this.handleDropdownOpen);
      document.addEventListener('YG:progress-end', this.handleProgressEnd);
      this.observeVisibility();
      this.initializeDefaultStep();
    }

    disconnectedCallback() {
      document.removeEventListener('YG:dropdown-open', this.handleDropdownOpen);
      document.removeEventListener('YG:progress-end', this.handleProgressEnd);
      this.intersectionObserver?.disconnect();
    }

    observeVisibility() {
      if (!('IntersectionObserver' in window)) {
        this.isInViewport = true;
        return;
      }

      this.intersectionObserver = new IntersectionObserver(this.handleIntersection, {
        threshold: 0.2
      });
      this.intersectionObserver.observe(this);
    }

    handleIntersection(entries) {
      const entry = entries[0];
      this.isInViewport = entry.isIntersecting;

      if (this.isInViewport) {
        this.resumeActiveStep();
      } else {
        this.pauseActiveStep();
      }
    }

    handleDropdownOpen(event) {
      if (event.detail?.id) {
        this.currentStep(event.detail.id);
      }
    }

    handleProgressEnd(event) {
      if (event.detail?.id) {
        this.nextStep(event.detail.id);
      }
    }

    initializeDefaultStep() {
      requestAnimationFrame(() => {
        const activeItem = this.querySelector('.yg-process-steps-item[open]') || this.$sectionEl['accordionList'][0];
        const activeId = activeItem?.getAttribute('data-id');

        if (!activeId) {
          return;
        }

        if (typeof activeItem.openDropdown === 'function' && !activeItem.hasAttribute('open')) {
          activeItem.openDropdown();
          return;
        }

        this.currentStep(activeId);
      });
    }

    nextStep(id) {
      if (!this.isActiveStep(id)) {
        return;
      }
      this.$sectionEl['accordionList'].forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          let indexNext = i == this.$sectionEl['accordionList'].length - 1 ? 0 : i + 1;
          this.currentStepIndex = indexNext;
        }
      });
      
      this.$sectionEl['accordionList'][this.currentStepIndex]?.openDropdown();
    }

    currentStep(id) {
      if (!this.isCurrentStep(id)) {
        return;
      }
      this.setActiveControl(id);

      if (!this.isInViewport) {
        this.pauseActiveStep();
        return;
      }

      this.playVideo(id);
      this.startProgressForId(id);
      this.hasStarted = true;
    }

    isCurrentStep(id) {
      let isCurrentStep = false;
      this.$sectionEl['accordionList'].forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          isCurrentStep = true;
        }
      });
      return isCurrentStep;
    }

    isActiveStep(id) {
      return this.$sectionEl['accordionList'][this.currentStepIndex]?.getAttribute('data-id') === id;
    }

    setActiveControl(id) {
      this.$sectionEl['controls'].forEach((item) => {
        if (item.getAttribute('data-id') === id) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });
    }

    startProgressForId(id) {
      this.$sectionEl['progressBars']?.forEach((item, i) => {
        if (item.getAttribute('data-id') === id) {
          this.currentStepIndex = i;
          item.classList.remove('is-paused');
          const video = this.getVideoById(id);
          if (video) {
            item.setVideo(video);
          }
          item.startProgress();
        } else {
          item.stopProgress();
        }
      });
    }

    getVideoById(id) {
      let videoEl = null;
      this.$sectionEl['controls'].forEach((item) => {
        if (item.querySelector('yg-video')?.getAttribute('data-id') === id) {
          videoEl = item.querySelector('yg-video');
        }
      });
      return videoEl;
    }

    getActiveId() {
      return this.$sectionEl['accordionList'][this.currentStepIndex]?.getAttribute('data-id');
    }

    getActiveProgressBar() {
      const activeId = this.getActiveId();
      return Array.from(this.$sectionEl['progressBars'] || []).find((item) => item.getAttribute('data-id') === activeId);
    }

    getPlayableVideoElement(videoEl) {
      if (!videoEl) return null;
      const isMobile = window.innerWidth < 699;
      const videos = videoEl.querySelectorAll('.yg-video-iframe');
      const visibleVideo = Array.from(videos).find((video) => {
        if (isMobile) {
          return !video.classList.contains('hide-pc');
        }
        return !video.classList.contains('hide-mobile');
      });

      return visibleVideo || videos[0] || null;
    }

    pauseVideoWithoutReset(videoEl) {
      const playableVideo = this.getPlayableVideoElement(videoEl);
      if (playableVideo && typeof playableVideo.pause === 'function') {
        playableVideo.pause();
        return;
      }

      if (typeof videoEl?.pauseVideo === 'function') {
        videoEl.pauseVideo();
      }
    }

    pauseActiveStep() {
      const activeId = this.getActiveId();
      const activeProgressBar = this.getActiveProgressBar();
      const activeVideo = this.getVideoById(activeId);

      activeProgressBar?.classList.add('is-paused');
      this.pauseVideoWithoutReset(activeVideo);
    }

    resumeActiveStep() {
      const activeId = this.getActiveId();

      if (!activeId) {
        return;
      }

      if (!this.hasStarted) {
        this.currentStep(activeId);
        return;
      }

      this.getActiveProgressBar()?.classList.remove('is-paused');
      this.playVideo(activeId, true);
    }

    pauseAllVideos(exceptId = null) {
      this.$sectionEl['controls'].forEach((item) => {
        const videoEl = item.querySelector('yg-video');
        if (exceptId && videoEl?.getAttribute('data-id') === exceptId) {
          return;
        }
        if (typeof videoEl?.pauseVideo === 'function') {
          videoEl.pauseVideo();
        }
      });
    }

    playVideo(id, keepCurrentTime = false) {
      this.pauseAllVideos(keepCurrentTime ? id : null);
      const videoEl = this.getVideoById(id);
      if (typeof videoEl?.playVideo === 'function') {
        videoEl.playVideo();
        return;
      }

      if (videoEl) {
        customElements.whenDefined('yg-video').then(() => {
          if (this.isActiveStep(id) && this.isInViewport && typeof videoEl.playVideo === 'function') {
            videoEl.playVideo();
          }
        });
      }
    }
  }

  if (!window.customElements.get('yg-process-steps')) {
    window.customElements.define('yg-process-steps', YGProcessSteps);
  }

  } catch(e) { console.error(e); }
})();
})();
